import React from 'react';
import { Phone, Mail, Clock, MapPin } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import QuoteForm from '../components/QuoteForm';

const Contact = () => {
  const serviceAreas = [
    'Vancouver', 'Surrey', 'Delta', 'Langley', 'Burnaby', 
    'Abbotsford', 'Chilliwack', 'Mission', 'Vancouver Island', 'Victoria'
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6 animate-fadeInUp">
            Get a fast quote
          </h1>
          <p className="text-lg sm:text-xl text-gray-600 animate-fadeInUp animation-delay-100">
            Send your move details and we'll reply quickly
          </p>
        </div>
      </section>

      {/* Contact Content */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Contact Information */}
            <div className="animate-slideInLeft">
              <h2 className="text-2xl font-bold text-gray-900 mb-6">
                Contact Information
              </h2>
              
              <div className="space-y-6 mb-8">
                <div className="flex items-start">
                  <Phone className="text-orange-500 mr-4 flex-shrink-0 mt-1" size={24} />
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-1">Phone</h3>
                    <a 
                      href="tel:7783260735" 
                      className="text-gray-600 hover:text-orange-500 transition-colors text-lg"
                    >
                      (778) 326-0735
                    </a>
                  </div>
                </div>

                <div className="flex items-start">
                  <Mail className="text-orange-500 mr-4 flex-shrink-0 mt-1" size={24} />
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-1">Email</h3>
                    <a 
                      href="mailto:contact@blackbrosdelivery.ca" 
                      className="text-gray-600 hover:text-orange-500 transition-colors"
                    >
                      contact@blackbrosdelivery.ca
                    </a>
                  </div>
                </div>

                <div className="flex items-start">
                  <Clock className="text-orange-500 mr-4 flex-shrink-0 mt-1" size={24} />
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-1">Hours</h3>
                    <p className="text-gray-600">Monday – Sunday</p>
                    <p className="text-gray-600">8:00 AM – 8:00 PM</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <MapPin className="text-orange-500 mr-4 flex-shrink-0 mt-1" size={24} />
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-2">Service Areas</h3>
                    <div className="flex flex-wrap gap-2">
                      {serviceAreas.map((area, index) => (
                        <span
                          key={index}
                          className="inline-block bg-gray-100 px-3 py-1 rounded-full text-gray-700 text-sm"
                        >
                          {area}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>

              {/* Quick Actions for Mobile */}
              <div className="lg:hidden space-y-3 mb-8">
                <a
                  href="tel:7783260735"
                  className="block w-full text-center px-6 py-3 bg-orange-500 text-white font-semibold rounded-full hover:bg-orange-600 transition-colors"
                >
                  <Phone size={20} className="inline mr-2" />
                  Call Now
                </a>
                <a
                  href="mailto:contact@blackbrosdelivery.ca"
                  className="block w-full text-center px-6 py-3 bg-gray-100 text-gray-900 font-semibold rounded-full hover:bg-gray-200 transition-colors"
                >
                  <Mail size={20} className="inline mr-2" />
                  Send Email
                </a>
              </div>
            </div>

            {/* Quote Form */}
            <div className="animate-slideInRight">
              <div className="bg-gray-50 rounded-lg p-6 sm:p-8 hover:shadow-lg transition-shadow duration-300">
                <h2 className="text-2xl font-bold text-gray-900 mb-6">
                  Request Your Quote
                </h2>
                <QuoteForm />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Map Placeholder Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-lg p-8 sm:p-12 text-center border border-gray-200">
            <MapPin className="text-orange-500 mx-auto mb-4" size={48} />
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Serving All of British Columbia
            </h3>
            <p className="text-gray-600 max-w-2xl mx-auto">
              From Vancouver to Victoria, we provide professional moving services throughout BC. 
              Whether you're moving locally or long-distance, our team is ready to help.
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Contact;
